import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Navbar from "./components/navbar/Navbar";

import auth from "./services/authService";
//import NavBar from "./components/menu/navBarF";

import NotFound from "./components/notFound";
import LoginForm from "./components/session/loginForm";
import Logout from "./components/session/logout";
import ProtectedRoute from "./components/common/protectedRoute";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./register.css";

import Search from './components/search/search';

import {getPrivilege} from './services/fire';

import BranchContext from "./components/context/branch";
import PrivilegeContext from './components/context/privilege';

import Itemlist from "./components/main/itemlist";
import Accountlist from "./components/main/accountlist";
import Grouplist from "./components/main/grouplist";
import Itemadd from "./components/main/additem";
import Reportdashboard from "./components/dashboard/reportdashboard";
import Reportdata from "./components/report/reportdata";
import QrReader from "./components/main/qrscan";
import Adduser from './components/main/adduser';
import AddnewUser from './components/main/addnewUser';

import UserContext from './components/context/user';
import Reportcheck from './components/report/reportcheck';



const mql = window.matchMedia(`(min-width: 992px)`);

class App extends Component {
  state = {
    currentBranch : {_id:'',name:""},
    privilege :[]
  };

  constructor(props) {
    super(props);
    this.state = {
      sidebarDocked: mql.matches,
      sidebarOpen: false
    };

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    
  }

  handelSelectedBranch = (brandid) => {
      this.setState({currentBranch: brandid})
  } 
  handelOnChange =(event) => {

    this.setState({privilege : event});

  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  mediaQueryChanged() {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false });
  }

  componentDidMount() {
    mql.addListener(this.mediaQueryChanged);

    const user = auth.getCurrentUser();
    const currentBranch =auth.getCurrentBranch();
    this.loadPrivilege();   
// console.log(currentBranch);
    this.setState({currentBranch});
    this.setState({ user });
  }

  toggleSideBar = () => {

    const { sidebarOpen } = this.state;
  //  console.log(sidebarOpen)
  //  console.log(sidebarOpen)
    this.setState({ sidebarOpen: !sidebarOpen })


  }

  async loadPrivilege() {
    const { data: result } = await getPrivilege()

    if ( result) 
    {
      const privilege = result;    
      this.setState({ privilege: privilege })

    
    }
  }
  getdata = () => {
  window.addEventListener('scroll',() =>{
// console.log(window.scrollY);
  })
 }
 
//currentBranch = {currentBranch}
//console.log(currentBranch);
  render() {
    const { user } = this.state;
   const {currentBranch} = this.state;
   const {privilege} = this.state;
  

  if (!(privilege)){
    return <div>

    </div>
  }
   

    return (
      <UserContext.Provider value={user}>
      <PrivilegeContext.Provider value = {{privilege : privilege ,onChange:this.handelOnChange}}>
      <BranchContext.Provider
        value={{ currentBranch, onSelected: this.handelSelectedBranch }}
      >
        <React.Fragment>
          <ToastContainer />
          <Navbar user={user}  ></Navbar>
    
            <div className="container-fluid">
              <div className="row justify-content-center">
                <main
                  role="main"
                  
                  className="container-fluid"
                  style={{ padding: "5px", marginTop: "100px" ,marginLeft: "5px",marginRight:"5px"}}
                >
                  {/* <usestatelogin/> */}
                  <Switch>
                    
                    <ProtectedRoute path="/search" component={Search} />
                   
                    <ProtectedRoute path="/itemadd" component={Itemadd} />
                   
                    {/* <ProtectedRoute path ="/userondevice/:id" component = {props => <UserOndevice {...props} /> } />                               
                    <ProtectedRoute path ="/reportfacescan" component = {Reportfacescan}/>
                    <ProtectedRoute path ="/persononworking" component= {Persononworking}/> */}
                    <Route path="/login" component={LoginForm} />;
                    <ProtectedRoute path="/dashboard" component={Reportdashboard} />;
                    <ProtectedRoute path="/accountlist" component={Accountlist} />;
                    <ProtectedRoute path="/report" component={Reportdata} />;

                    <ProtectedRoute path="/qrscan" component={QrReader} />;
                    <ProtectedRoute path="/adduser" component={Adduser} />;
                    <ProtectedRoute path="/addnewuser" component={AddnewUser} />;
                    <ProtectedRoute path="/itemlist" component={Itemlist} />;
                    <ProtectedRoute path="/grouplist" component={Grouplist} />;
                    <ProtectedRoute path="/logout" component={Logout} />;
                    <ProtectedRoute path="/Reportcheck" component={Reportcheck} />;
                    <Route path="/not-found" component={NotFound} />
                    <Redirect from="/" exact to="/dashboard" />

                    <Redirect to="/not-found" />
              
                  </Switch>
                </main>
              </div>
            </div>    
        </React.Fragment>
      </BranchContext.Provider>
      </PrivilegeContext.Provider>
      </UserContext.Provider>
    );
  }
}

export default App;
